import { IMAGES } from "@/lib/constants";
import ScrollReveal from "@/components/ScrollReveal";

const programmes = [
  {
    image: IMAGES.agriculture,
    title: "Supporting Our Farmers",
    subtitle: "Agriculture & FPO",
    desc: "Our Farmer Producer Organisation supports 5,000+ small and marginal farmers across Khunti with certified seeds, modern tools, sustainable farming training, collective bargaining power, and direct market linkages — eliminating middlemen and raising farmer incomes.",
    stat: "Target: 100,000 farmers by 2029",
  },
  {
    image: IMAGES.healthcare,
    title: "Healthcare for Every Village",
    subtitle: "Healthcare",
    desc: "Mobile health clinics serving remote tribal areas, blood donation camps, nutrition awareness drives for pregnant women and children, preventive health camps, and the vision of establishing 2-3 large-scale community hospitals by 2028 offering treatment starting at just Rs.5 for economically weaker families.",
    stat: "Vision: Rs.5 treatment for the poorest families",
  },
  {
    image: IMAGES.children,
    title: "Education That Reaches Every Child",
    subtitle: "Education",
    desc: "Rural school support programmes, scholarship funds for tribal students, digital literacy drives bringing technology to village classrooms, and partnerships with urban institutions for mentoring and exposure visits.",
    stat: "50+ villages with education programmes",
  },
  {
    image: IMAGES.womenEmpowerment,
    title: "Women Leading the Way",
    subtitle: "Women Empowerment",
    desc: "Self-help groups, vocational skill training, financial literacy and inclusion programmes, micro-enterprise development, and leadership development for women in rural governance. 1,800+ women-led households directly supported with food, hygiene kits, and livelihood resources.",
    stat: "1,800+ women-led households served",
  },
  {
    image: IMAGES.youth,
    title: "Building Tomorrow's Leaders",
    subtitle: "Youth Leadership",
    desc: "Campus chapter networks, civic engagement drives, leadership training workshops, social entrepreneurship incubation, and structured volunteer programmes that turn young people into changemakers in their own communities.",
    stat: "200+ youth volunteers trained",
  },
  {
    image: IMAGES.distribution,
    title: "When Crisis Strikes, We Respond",
    subtitle: "Disaster Relief",
    desc: "Rapid-response emergency aid including ration distribution, temporary shelter, rehabilitation support, and long-term recovery planning for flood, drought, and crisis-affected communities in Jharkhand.",
    stat: "Multiple districts covered in emergency response",
  },
];

export default function ProgrammesPage() {
  return (
    <main data-testid="programmes-page">
      {/* Hero */}
      <section className="relative min-h-[50vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${IMAGES.seeds})` }} />
        <div className="absolute inset-0 bg-[#1B4332]/65" />
        <div className="relative z-10 max-w-4xl mx-auto px-4 text-center pt-20">
          <ScrollReveal>
            <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl text-white font-bold mb-4">
              Six Programmes.<br />One Integrated Mission.
            </h1>
            <p className="text-white/80 text-base sm:text-lg font-outfit max-w-xl mx-auto">
              Each initiative reinforces the others — because real development is never siloed.
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* Programme Blocks */}
      <section className="bg-[#F0F7F4]">
        {programmes.map((prog, i) => (
          <div
            key={i}
            data-testid={`programme-block-${i}`}
            className={`py-16 md:py-24 ${i % 2 === 0 ? 'bg-white' : 'bg-[#F0F7F4]'}`}
          >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className={`grid lg:grid-cols-2 gap-12 lg:gap-16 items-center ${i % 2 !== 0 ? 'lg:[direction:rtl]' : ''}`}>
                <ScrollReveal>
                  <img
                    src={prog.image}
                    alt={prog.title}
                    className="w-full h-64 md:h-80 lg:h-96 object-cover rounded-xl shadow-lg"
                    loading="lazy"
                    style={{ direction: 'ltr' }}
                  />
                </ScrollReveal>
                <ScrollReveal delay={0.2}>
                  <div style={{ direction: 'ltr' }}>
                    <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#D4A843] font-outfit mb-3">
                      {prog.subtitle}
                    </p>
                    <h2 className="font-playfair text-2xl sm:text-3xl lg:text-4xl text-[#1B4332] font-bold mb-6 leading-tight">
                      {prog.title}
                    </h2>
                    <p className="text-[#333] font-outfit leading-relaxed mb-6">
                      {prog.desc}
                    </p>
                    <div className="inline-block bg-[#1B4332]/5 border border-[#2D6A4F]/20 rounded-lg px-4 py-2">
                      <p className="text-[#2D6A4F] font-outfit font-semibold text-sm">{prog.stat}</p>
                    </div>
                  </div>
                </ScrollReveal>
              </div>
            </div>
          </div>
        ))}
      </section>
    </main>
  );
}
